
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap/svg.bootstrap';
import './bootstrap';

//Bootstrap-datepicker
import 'bootstrap-datepicker/js/bootstrap-datepicker';
import './bootstrap/bootstrap-datepicker';
import './bootstrap/image-upload';
import 'leaflet/dist/leaflet';

import './region-checkbox-max';
import './toggle-region-radius';

import { businessApplicationFormVueConfig } from './vue-configs/businessApplicationForm';
import { leadFormVueConfig } from './vue-configs/leadForm';
import { reclaimFormVueConfig } from './vue-configs/reclaimForm';
import { surveyFormVueConfig } from './vue-configs/surveyForm';
import { contactFormVueConfig } from './vue-configs/contactForm';
import { feedbackFormVueConfig } from './vue-configs/feedbackForm';
import Vue from 'vue/dist/vue.js';

if (document.getElementById('business-application-form-app')) {
    const businessApplicationFormApp = new Vue(businessApplicationFormVueConfig);
}

if (document.getElementById('lead-form-app')) {
    const leadFormApp = new Vue(leadFormVueConfig);
}

if (document.getElementById('reclaim-form-app')) {
    const leadFormApp = new Vue(reclaimFormVueConfig);
}

if (document.getElementById('survey-form-app')) {
    const surveyFormApp = new Vue(surveyFormVueConfig);
}

if (document.getElementById('contact-form-app')) {
    const contactFormApp = new Vue(contactFormVueConfig);
}

if (document.getElementById('feedback-form-app')) {
    const feedbackFormApp = new Vue(feedbackFormVueConfig);
}
